import Head from 'next/head';

export const HomepageJsonLd: React.FC = () => {
  const jsonLdData = {
    '@context': 'https://schema.org',
    '@type': 'NewsMediaOrganization',
    name: 'Coinpaper',
    description:
      'Latest news about crypto industry, every day on Coinpaper. Read about Bitcoin, Ethereum, Research & Analysis, and more.',
    url: 'https://coinpaper.com',
    logo: 'https://coinpaper.com/img/logo.png',
    foundingDate: 2021,
    publisher: 'Coinpaper',
    author: {
      '@type': 'Organization',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'United Arab Emirates',
        addressLocality: 'Hor Al Anz',
        addressRegion: 'Dubai',
        postalCode: '00000',
        streetAddress: '102, RAHMANY G+2',
      },
      foundingDate: 2021,
      legalName: 'Coinpaper',
      logo: 'https://coinpaper.com/img/logo.png',
      name: 'Coinpaper',
    },
    sameAs: [
      'https://instagram.com/coinpapercom',
      'https://x.com/coinpapercom',
      'https://www.facebook.com/profile.php?id=61567914871409',
      'https://www.linkedin.com/company/coinpaper-com/',
      'https://coinmarketcap.com/community/profile/Coinpaper/',
      'https://t.me/s/coinpapernews',
      'https://www.youtube.com/@Coinpapercom',
    ],
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdData) }}
      />
    </Head>
  );
};
